export default "__VITE_ASSET__nekpGRo7__"